import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextInput from './text-input';

import * as S from './styles';

export default class TextInputs extends Component {
  renderTextInput(key) {
    const defaultValue = this.props.minMax[key];
    const selected = this.props.selected ? this.props.selected[key] : null;
    return (
      <TextInput
        key={`input-${key}-${defaultValue}`}
        id={key}
        default={`${defaultValue}`}
        selected={selected}
        onChange={this.props.onChange}
      />
    );
  }

  render() {
    return (
      <S.InputWrapper layout={this.props.layout}>
        {this.props.keys.map(this.renderTextInput, this)}
      </S.InputWrapper>
    );
  }
}

TextInputs.propTypes = {
  layout: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  minMax: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      from: PropTypes.number,
      to: PropTypes.number,
    }),
  ]),
};

TextInputs.defaultProps = {
  selected: {
    from: null,
    to: null,
  },
};
